import React from "react";
import axios from "axios";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./src/styles/global.css";
import { ThemeProvider } from "./src/context/ThemeContext";
import muiTheme from "./src/theme/muiTheme";
import { handleUnauthorized } from "./src/services/auth";

// Sesión admin vencida (JWT): cerrar y volver al login en cualquier llamada axios.
if (typeof window !== "undefined" && !window.__shiftAuthInterceptor) {
  window.__shiftAuthInterceptor = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (handleUnauthorized(error)) {
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
}

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {element}
    </MuiThemeProvider>
  </ThemeProvider>
);
